/* eslint-disable no-nested-ternary */
import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { Phones } from './PatientElements';
import { ADMITTED_ON, DISCHARGED_ON, DISCHARGE_REASON, ETHNICITY, MARITAL_STATUS, RACE, ROOM_NUMBER } from '../constants';
import { parseAddress, parseName, parsePhones } from '../utils';

var _ref = /*#__PURE__*/React.createElement(View, null);

export const PatientHeader = ({
  patient,
  condition,
  siteName,
  currentFacility
}) => {
  const patientFullName = parseName(patient);
  return /*#__PURE__*/React.createElement(View, {
    style: styles.width100
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.row
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.printerHeaderText
  }, patientFullName)), /*#__PURE__*/React.createElement(HeaderDetails, {
    patient: patient,
    condition: condition
  }), /*#__PURE__*/React.createElement(View, {
    style: [styles.row, styles.alignItemsCenter]
  }, currentFacility && siteName ? /*#__PURE__*/React.createElement(AdmitStatus, {
    patient: patient,
    currentFacility: currentFacility,
    siteName: siteName
  }) : _ref, /*#__PURE__*/React.createElement(Personals, {
    patient: patient
  })));
};

const getPrimeDiagnosis = condition => condition.diagnoses && (condition.diagnoses.diagnosis.description || condition.diagnoses.diagnosis.find(diagnosis => diagnosis.type === 'prime').description);

var _ref2 = /*#__PURE__*/React.createElement(View, null);

const HeaderDetails = ({
  patient,
  condition
}) => {
  const phones = parsePhones(patient);
  const patientDOB = patient.dob && `${patient.dob} (${patient.age})`;
  const primeDiagnosis = condition && getPrimeDiagnosis(condition);
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.detailsUnderNameHeader, styles.width100, styles.justifyContentAround]
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.dob}:`), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, patientDOB)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.birthGender}:`), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, patient.sex)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.currentGenderIdentity}:`), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, patient.genderidentity)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.preferredGenderPronouns}:`), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, patient.preferredpronoun)), /*#__PURE__*/React.createElement(View, {
    style: styles.width20
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, primeDiagnosis), phones ? /*#__PURE__*/React.createElement(Phones, {
    phones: phones
  }) : _ref2));
};

var _ref3 = /*#__PURE__*/React.createElement(View, null);

const AdmitHeader = ({
  loc,
  facName,
  roomNumber
}) => /*#__PURE__*/React.createElement(Text, {
  style: [styles.pYPointOneCm, styles.FacesheetText]
}, loc, " at", /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, ` ${facName}`), roomNumber ? /*#__PURE__*/React.createElement(Text, null, ", Room:", /*#__PURE__*/React.createElement(Text, {
  style: styles.FacesheetHeaderField
}, ` ${roomNumber}`)) : _ref3);

const AdmitStatus = ({
  patient,
  currentFacility,
  siteName
}) => {
  const admittedOn = patient[ADMITTED_ON] && `Admitted to ${siteName} as of ${patient[ADMITTED_ON]}`;
  const dischargedOn = patient[DISCHARGED_ON] && `Discharged from ${siteName} as of ${patient[DISCHARGED_ON]}`;
  const dischargeReason = patient[DISCHARGE_REASON] && `Reason: ${patient[DISCHARGE_REASON]}`;
  return /*#__PURE__*/React.createElement(View, {
    style: styles.width50
  }, /*#__PURE__*/React.createElement(AdmitHeader, {
    loc: patient.loc,
    facName: currentFacility.name,
    roomNumber: patient[ROOM_NUMBER]
  }), /*#__PURE__*/React.createElement(Text, {
    style: [styles.pYPointOneCm, styles.FacesheetText]
  }, admittedOn), /*#__PURE__*/React.createElement(Text, {
    style: [styles.pYPointOneCm, styles.FacesheetText]
  }, dischargedOn), /*#__PURE__*/React.createElement(Text, {
    style: [styles.pYPointOneCm, styles.FacesheetText]
  }, dischargeReason), patient.emergencyrisklevel && /*#__PURE__*/React.createElement(Text, {
    style: [styles.pYPointOneCm, styles.FacesheetText, {
      marginTop: 'auto'
    }]
  }, defaults.emergencyRiskLevel, ": ", patient.emergencyrisklevel));
};

const Personals = ({
  patient
}) => {
  const {
    street,
    city,
    state
  } = parseAddress(patient);
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.width50]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.pYPointOneCm, styles.FacesheetText, styles.fontWeightBold]
  }, `${defaults.ptHomeAddress}:`), /*#__PURE__*/React.createElement(Text, {
    style: [styles.pYPointOneCm, styles.FacesheetText, styles.paddingBottomPointFiveCm]
  }, street, " ", city, " ", state), /*#__PURE__*/React.createElement(Text, {
    style: [styles.pYPointOneCm, styles.FacesheetText]
  }, patient[MARITAL_STATUS], " / ", patient[RACE], " / ", patient[ETHNICITY]));
};